export default "https://cdn-web.disco.co/cohort-based-course-260738d55d9c96f8745326bd4af3e618.png";